module.exports = __webpack_public_path__ + "img/edpsweb_title.e755b7e5.jpg";